export const redirectToEndoso = (param) => {
    return (props) => {
        try {
            const searchData = param.search.replaceAll("{poliza}", props.dataProps.data.nro_pol)
                .replaceAll("{sucursal}", props.dataProps.data.Sucursal)
                .replaceAll("{ramo}", props.dataProps.data.ramo);
            props.dataProps.dataProps.history.push({
                pathname: param.url,
                search: searchData
            });

        } catch (exception) {
            return {
                transaction: false,
                message: "fallo al redirigir a la página"
            }
        }

    };
}


export const redirectToPlanesPago = (param) => {
    return (props) => {
        try {
            const searchData = param.search.replaceAll("{poliza}", props.dataProps.data.nro_pol)
                .replaceAll("{sucursal}", props.dataProps.data.Sucursal)
                .replaceAll("{ramo}", props.dataProps.data.ramo)
                .replaceAll("{id_pv}", props.dataProps.data.id_pv);
            props.dataProps.dataProps.history.push({
                pathname: param.url,
                search: searchData
            });

        } catch (exception) {
            return {
                transaction: false,
                message: "fallo al redirigir a la página"
            }
        }

    };
}